import "./Images.css";
import React, { Fragment } from "react";
import {
  ImageList,
  ImageListItem,
  Typography,
  ImageListItemBar,
  IconButton,
} from "@mui/material";
import { Dropzone, FileItem, FullScreenPreview } from "@dropzone-ui/react";
import DeleteIcon from "@mui/icons-material/Delete";

const Images = ({
  register,
  errors,
  handleImageChange,
  Images,
  propertyId,
  files,
  setFiles,
  isUploading,
  setIsUploading,
  imageSrc,
  setImageSrc,
  updateFiles,
  onDelete,
  handleSee,
  handleClean,
  updateNewFilesStatus,
  markAsUploaded,
  uploadImages,
  uploadStart,
  uploadFinish,
  oldImages,
  delOldImage,
}) => {
  const itemData = [
    // {
    //   img: "https://images.unsplash.com/photo-1551963831-b3b1ca40c98e",
    //   rows: 2,
    //   cols: 2,
    //   featured: true,
    // },
  ];

  oldImages.forEach((img) => {
    itemData.push({
      img,
      rows: 2,
      cols: 2,
      featured: true,
    });
  });

  return (
    <Fragment>
      {oldImages.length > 0 && (
        <ImageList sx={{ width: "100%" }} className="mb-3" cols={5}>
          {itemData.map((item, i) => (
            <ImageListItem key={item.img}>
              <img
                src={`${item.img}`}
                srcSet={`${item.img}`}
                alt={item.title}
                loading="lazy"
              />
              <ImageListItemBar
                actionIcon={
                  <IconButton
                    sx={{ color: "rgba(255, 255, 255, 0.54)" }}
                    aria-label={`info about ${item.title}`}
                    onClick={() => delOldImage(item.img, propertyId, i)}
                  >
                    <DeleteIcon />
                  </IconButton>
                }
              />
            </ImageListItem>
          ))}
        </ImageList>
      )}

      <Dropzone
        onChange={updateFiles}
        value={files}
        onClean={handleClean}
        maxFiles={20}
        maxFileSize={2998000}
        accept=".png,.jpg,.jpeg,.PNG,.JPG,.JPEG"
        uploadingMessage={"Uploading..."}
        clickable={!isUploading}
        header={!isUploading}
        disableScroll
      >
        {files.map((file, i) => (
          <FileItem
            {...file}
            key={i}
            preview
            onDelete={onDelete}
            onSee={handleSee}
            resultOnTooltip
            info
            hd
          />
        ))}

        <FullScreenPreview
          imgSource={imageSrc}
          openImage={imageSrc}
          onClose={(e) => handleSee(undefined)}
        />
      </Dropzone>

      <Typography className="fs-12 text-danger p-2">
        Only JPG and PNG files can be uploaded
      </Typography>
    </Fragment>
  );
};

export default Images;
